/** Node を含まない共通契約。UI と Lambda で callback 検証を同一にする。 */
import { parseLinkAuthorization, hasLinkControl } from '../../../backend/mcp/link-protocol';
export { mcpFeatureAvailability } from '../../../backend/mcp/feature-availability';
export {
  LINK_CLIENT_LABELS,
  LINK_CLIENTS,
  validCallbackUri,
  selectedLinkScope,
  hasLinkWriteScope,
  hasLinkReviewScope,
  hasLinkUploadScope,
  hasLinkGuiScope,
} from '../../../backend/mcp/link-protocol';
export type { LinkClient, LinkAuthorizationRequest } from '../../../backend/mcp/link-protocol';

export function parseAiAuthorization(search: string) {
  const params = new URLSearchParams(search);
  if (!params.has('authorize')) return null;
  if (
    params.get('authorize') !== '1' ||
    [...params.keys()].some((k) => params.getAll(k).length !== 1)
  )
    throw new Error('連携要求が不正です。AIと連携から接続し直してください。');
  try {
    return parseLinkAuthorization({ ...Object.fromEntries(params), scope: 'read' });
  } catch {
    throw new Error('連携要求が不正です。AIと連携から接続し直してください。');
  }
}

/** 復帰先は AI 連携の同一画面だけ。外部 URL や URL 正規化による抜け道は受け付けない。 */
export function safeAiReturnTo(value: string | null): string {
  if (!value || value.length > 8192 || /[\\#]/.test(value) || hasLinkControl(value)) return '/';
  if (value !== '/ai-connections' && !value.startsWith('/ai-connections?')) return '/';
  return value;
}

export function aiConnectionRing(hostname: string): 'prd' | 'dev' | null {
  if (hostname === 'app.ace-collect.com') return 'prd';
  if (['dev-app.ace-collect.com', 'localhost', '127.0.0.1'].includes(hostname)) return 'dev';
  return null;
}
